import PropTypes from 'prop-types';
import {TextArea} from '@/components/atoms';
import {TextInputField} from '@/components/molecules';
import {
  SALES_TARGET_SIMPLE_DISPLAY_FIELDS,
  STRING_SCHEMA
} from './salesTargetSimpleDisplayShared';

export const SalesTargetDisplayInformationSection = ({
  languages,
  content,
  onContentChange,
  targetTypeLabel,
  className = '',
  targetTypeLabelClassName = 'mb-1 text-sm font-bold',
  targetTypeValueClassName = 'mb-6 text-sm font-semibold'
}) => (
  <div className={className}>
    <h3 className={targetTypeLabelClassName}>Target Type</h3>
    <p className={targetTypeValueClassName}>{targetTypeLabel}</p>

    <div className='grid grid-cols-1 gap-x-6 gap-y-6 md:grid-cols-2 lg:grid-cols-3'>
      {languages.map((lang) => (
        <div key={lang.code} className='min-w-0'>
          <p className='mb-4 text-sm font-bold text-white'>{lang.title}</p>
          {SALES_TARGET_SIMPLE_DISPLAY_FIELDS.map((field) => {
            const data = content?.[lang.code] || {};
            const commonProps = {
              value: data[field.key] || '',
              label: field.uiSchema.label,
              updateValue: (val, hasError) =>
                onContentChange(lang.code, field.key, val, hasError)
            };

            return (
              <div key={`${field.key}-${lang.code}`} className='mb-4'>
                {field.type === 'input' ? (
                  <TextInputField
                    {...commonProps}
                    schema={STRING_SCHEMA}
                    uiSchema={field.uiSchema}
                    visible
                  />
                ) : (
                  <TextArea
                    {...commonProps}
                    uiSchema={field.uiSchema}
                    trim={false}
                  />
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  </div>
);

SalesTargetDisplayInformationSection.propTypes = {
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      title: PropTypes.string
    })
  ).isRequired,
  content: PropTypes.object,
  onContentChange: PropTypes.func.isRequired,
  targetTypeLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
  targetTypeLabelClassName: PropTypes.string,
  targetTypeValueClassName: PropTypes.string
};
